import * as Mod1 from "./discourse/admin-discourse-places-plugin-route-map";
import * as Mod2 from "./discourse/components/modal/chat-place-event-link-picker";
import * as Mod3 from "./discourse/components/modal/place-picker";
import * as Mod4 from "./discourse/components/place-map";
import * as Mod5 from "./discourse/components/reviewable/dpl-place-edit";
import * as Mod6 from "./discourse/components/reviewable/dpl-place-review";
import * as Mod7 from "./discourse/components/reviewable/dpl-place-type";
import * as Mod8 from "./discourse/connectors/full-page-search-before-results/discourse-places-results.gjs";
import * as Mod9 from "./discourse/connectors/search-menu-results-bottom/discourse-places-results.gjs";
import * as Mod10 from "./discourse/connectors/user-activity-bottom/places-list.gjs";
import * as Mod11 from "./discourse/controllers/discourse-place";
import * as Mod12 from "./discourse/controllers/discourse-places-collection";
import * as Mod13 from "./discourse/controllers/discourse-places-collections";
import * as Mod14 from "./discourse/controllers/discourse-places-saved";
import * as Mod15 from "./discourse/controllers/discourse-places";
import * as Mod16 from "./discourse/controllers/user-activity/places";
import * as Mod17 from "./discourse/discourse-places-route-map";
import * as Mod18 from "./discourse/discourse-places-user-activity-route-map";
import * as Mod19 from "./discourse/initializers/discourse-places-admin-plugin-configuration-nav";
import * as Mod20 from "./discourse/initializers/discourse-places-chat-composer";
import * as Mod21 from "./discourse/initializers/discourse-places-composer";
import * as Mod22 from "./discourse/initializers/discourse-places-mentions";
import * as Mod23 from "./discourse/initializers/discourse-places-reviewables";
import * as Mod24 from "./discourse/initializers/discourse-places-search";
import * as Mod25 from "./discourse/initializers/discourse-places-sidebar";
import * as Mod26 from "./discourse/lib/place-map";
import * as Mod27 from "./discourse/lib/place-type-graphic";
import * as Mod28 from "./discourse/modifiers/dpl-dismiss-on-outside";
import * as Mod29 from "./discourse/routes/discourse-place";
import * as Mod30 from "./discourse/routes/discourse-places-category";
import * as Mod31 from "./discourse/routes/discourse-places-collection";
import * as Mod32 from "./discourse/routes/discourse-places-collections";
import * as Mod33 from "./discourse/routes/discourse-places-saved";
import * as Mod34 from "./discourse/routes/discourse-places";
import * as Mod35 from "./discourse/routes/user-activity/places";
import * as Mod36 from "./discourse/templates/discourse-place";
import * as Mod37 from "./discourse/templates/discourse-places-collection";
import * as Mod38 from "./discourse/templates/discourse-places-collections";
import * as Mod39 from "./discourse/templates/discourse-places-saved";
import * as Mod40 from "./discourse/templates/discourse-places";
import * as Mod41 from "./discourse/templates/user-activity/places";
import * as Mod42 from "./lib/discourse-markdown/place-inline";
import * as Mod43 from "./vendor/maplibre-gl/maplibre-gl";
const compatModules = {
  "discourse/admin-discourse-places-plugin-route-map": Mod1,
  "discourse/components/modal/chat-place-event-link-picker": Mod2,
  "discourse/components/modal/place-picker": Mod3,
  "discourse/components/place-map": Mod4,
  "discourse/components/reviewable/dpl-place-edit": Mod5,
  "discourse/components/reviewable/dpl-place-review": Mod6,
  "discourse/components/reviewable/dpl-place-type": Mod7,
  "discourse/connectors/full-page-search-before-results/discourse-places-results": Mod8,
  "discourse/connectors/search-menu-results-bottom/discourse-places-results": Mod9,
  "discourse/connectors/user-activity-bottom/places-list": Mod10,
  "discourse/controllers/discourse-place": Mod11,
  "discourse/controllers/discourse-places-collection": Mod12,
  "discourse/controllers/discourse-places-collections": Mod13,
  "discourse/controllers/discourse-places-saved": Mod14,
  "discourse/controllers/discourse-places": Mod15,
  "discourse/controllers/user-activity/places": Mod16,
  "discourse/discourse-places-route-map": Mod17,
  "discourse/discourse-places-user-activity-route-map": Mod18,
  "discourse/initializers/discourse-places-admin-plugin-configuration-nav": Mod19,
  "discourse/initializers/discourse-places-chat-composer": Mod20,
  "discourse/initializers/discourse-places-composer": Mod21,
  "discourse/initializers/discourse-places-mentions": Mod22,
  "discourse/initializers/discourse-places-reviewables": Mod23,
  "discourse/initializers/discourse-places-search": Mod24,
  "discourse/initializers/discourse-places-sidebar": Mod25,
  "discourse/lib/place-map": Mod26,
  "discourse/lib/place-type-graphic": Mod27,
  "discourse/modifiers/dpl-dismiss-on-outside": Mod28,
  "discourse/routes/discourse-place": Mod29,
  "discourse/routes/discourse-places-category": Mod30,
  "discourse/routes/discourse-places-collection": Mod31,
  "discourse/routes/discourse-places-collections": Mod32,
  "discourse/routes/discourse-places-saved": Mod33,
  "discourse/routes/discourse-places": Mod34,
  "discourse/routes/user-activity/places": Mod35,
  "discourse/templates/discourse-place": Mod36,
  "discourse/templates/discourse-places-collection": Mod37,
  "discourse/templates/discourse-places-collections": Mod38,
  "discourse/templates/discourse-places-saved": Mod39,
  "discourse/templates/discourse-places": Mod40,
  "discourse/templates/user-activity/places": Mod41,
  "lib/discourse-markdown/place-inline": Mod42,
  "vendor/maplibre-gl/maplibre-gl": Mod43,
};
export { compatModules };
export default compatModules;
